import { Context, type Effect, Layer } from "effect";
import type { EditorRevealBindings, EditorRevealFailure, EditorRevealRequest, EditorRevealTarget } from "./reveal-model.ts";

export class EditorRevealIo extends Context.Service<EditorRevealIo, {
  readonly apply: (editor: EditorRevealTarget, request: EditorRevealRequest) => Effect.Effect<void, EditorRevealFailure>;
}>()("workerstation/frontend/EditorRevealIo") {}
export const EditorRevealIoTest = (io: typeof EditorRevealIo.Service) => Layer.succeed(EditorRevealIo, io);
export class EditorReveals extends Context.Service<EditorReveals, {
  readonly reveal: (request: unknown, bindings: EditorRevealBindings) => Effect.Effect<void, EditorRevealFailure>;
}>()("workerstation/frontend/EditorReveals") {}
export const EditorRevealsTest = (service: typeof EditorReveals.Service) => Layer.succeed(EditorReveals, service);
